import { AutocompletePrediction } from '@fhs/expo-maps';

export interface AutocompleteDropdownProps {
  /** location predictions (these show in the options dropdown as the user types) */
  predictions: AutocompletePrediction[] | null | undefined;
  /** Fired when a dropdown option is chosen, or when the field is cleared via the clear control (empty address / placeId). */
  onSelection: ({ address, placeId }: { address: string; placeId?: string }) => void;
  /** This is fired when the user types, when an option in selected, or when the text input is cleared via the icon */
  onInputChange: (newInputValue: string) => void;
  /** If there is an invalid address, show this error message (currently only used on delivery form) */
  errorMessage?: string;
  /** Show this text if no address predictions are found for the given string */
  noPredictionsFoundText: string;
  /** Title for the 'clear text' icon that will be read to a user via screen reader */
  clearTextIconTitle: string;
  /** Overrides accessible name of the text field (web/native); defaults to `label`. */
  accessibilityLabel?: string;
  /** When `fieldLabelledBy` is set, used as the accessible name on native; web uses the heading via `aria-labelledby`. */
  accessibilityLabelWhenLabelledByNative?: string;
  /** `nativeID` of a heading that labels this field (`aria-labelledby` on web). */
  fieldLabelledBy?: string;
  /** `nativeID` of helper copy (`aria-describedby` on web / `accessibilityDescribedBy` on native). */
  fieldDescribedBy?: string;
  /** Read after the name when the field is focused (e.g. supplementary copy); not merged into the name. */
  accessibilityHint?: string;
  /** Web-only escape hatch for route-specific Tab focus handoff after selection. */
  onWebInputTab?: (event: KeyboardEvent) => void;
}
